module.exports = __webpack_public_path__ + "static/media/rec2.b25aac28.jpg";